import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';

export interface DialogFechaLiquidacionData {
  mensaje?: string;
}

export interface DialogFechaLiquidacionResult {
  fechaCierre: string; // dd/MM/yyyy
}

@Component({
  selector: 'app-dialog-fecha-liquidacion',
  templateUrl: './dialog-fecha-liquidacion.component.html',
  styleUrls: ['./dialog-fecha-liquidacion.component.css']
})
export class DialogFechaLiquidacionComponent implements OnInit {

  form: FormGroup;
  mensaje: string;

  constructor(
    public dialogRef: MatDialogRef<DialogFechaLiquidacionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogFechaLiquidacionData,
    private fb: FormBuilder,
  ) {
    this.mensaje = data.mensaje || 'Seleccione la fecha de cierre para generar la liquidación';

    this.form = this.fb.group({
      fechaCierre: [new Date(), Validators.required]
    });
  }

  ngOnInit(): void {}

onAceptar(): void {
  if (this.form.valid) {
    const fecha = this.form.controls['fechaCierre'].value as Date;
    const datePipe = new DatePipe('en-US');
    const fechaFormateada = datePipe.transform(fecha, 'yyyy-MM-dd');

    const result: DialogFechaLiquidacionResult = {
      fechaCierre: fechaFormateada!  // El ! le dice a TS que no será null
    };

    this.dialogRef.close(result);
  }
}

  onCancelar(): void {
    this.dialogRef.close(null);
  }
}
